// hooks/NewCaseView/useFormInitialization.js

import { useState, useEffect } from "react";
import { newCaseInitValues } from "../../components/shared/helpers/newCaseInitValues";
import { getUser } from "../../components/shared/helpers/helper";

const newCaseInit = newCaseInitValues();

/**
 * Hook to initialize and manage form state
 */
export const useFormInitialization = () => {
  const [initialValues, setInitialValues] = useState(newCaseInit);

  // Set investigator name from logged-in user on mount
  useEffect(() => {
    const user = getUser();
    setInitialValues((prev) => ({
      ...prev,
      case_details: {
        ...prev.case_details,
        assigment_information: {
          ...prev.case_details.assigment_information,
          investigator_name: user.user_name,
        },
      },
    }));
  }, []);

  return {
    initialValues,
  };
};

export default useFormInitialization;
